import { DealerDriverDto } from "types/dealerDrivers";
import {
  CoverageAreaDriverItem,
  CoverageAreaProps,
} from "store/modules/Logistics/types.store";

import { DriverOption } from "./hooks/useMapAreaDriverSelection";

function sortDriversByPriority(
  drivers: CoverageAreaDriverItem[],
): CoverageAreaDriverItem[] {
  return [...drivers].sort((a, b) => a.priority - b.priority);
}

export function getDriversFromCoverageAreaField(
  coverageArea: CoverageAreaProps,
): CoverageAreaDriverItem[] {
  const drivers = coverageArea.drivers ?? [];
  if (drivers.length === 0) {
    return [];
  }
  return sortDriversByPriority(
    drivers.filter((driver) => Boolean(driver.details?.id)),
  );
}

export function getCoverageAreaAssignedDriversForDisplay(
  coverageArea: CoverageAreaProps,
): CoverageAreaDriverItem[] {
  return getDriversFromCoverageAreaField(coverageArea);
}

export function hasCoverageAreaDriversForDisplay(
  coverageArea: CoverageAreaProps,
): boolean {
  return getCoverageAreaAssignedDriversForDisplay(coverageArea).length > 0;
}

function buildDriverOptionLabel(
  driverItem: CoverageAreaDriverItem,
  matchedDriver: DealerDriverDto | undefined,
): string {
  if (matchedDriver?.name) {
    return matchedDriver.name.trim();
  }

  return [driverItem.details?.name, driverItem.details?.surname]
    .filter(Boolean)
    .join(" ")
    .trim();
}

export function assignedDriversToDriverOptions(
  assignedDrivers: CoverageAreaDriverItem[],
  driversList: DealerDriverDto[] | undefined,
): DriverOption[] {
  return assignedDrivers
    .filter((driverItem) => Boolean(driverItem.details?.id))
    .map((driverItem) => {
      const matchedDriver = driversList?.find(
        (driver) => driver.id === driverItem.details.id,
      );

      return {
        id: driverItem.details.id,
        label: buildDriverOptionLabel(driverItem, matchedDriver),
      };
    });
}
